import { Box, Divider, Typography } from "@mui/material"
import type { FC } from "react"

import type { InvoicesSearchParams } from "../../schemas"

import { InvoicesStatusFilter } from "./InvoicesStatusFilter"
import { InvoicesTransactionTypeFilter } from "./InvoicesTransactionTypeFilter"
import { InvoicesVendorFilter } from "./InvoicesVendorFilter"

import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"

interface InvoicesFilterDrawerProps {
  searchParams: InvoicesSearchParams
  onClose: () => void
  onChange: <K extends keyof InvoicesSearchParams>(key: K, value: InvoicesSearchParams[K]) => void
  onClear: () => void
}

export const InvoicesFilterDrawer: FC<InvoicesFilterDrawerProps> = ({ searchParams, onClose, onChange, onClear }) => {
  const statuses = searchParams.statuses ?? []
  const { invoiceType, vendorCompanyId } = searchParams

  return (
    <SearchFilterDrawer open toggleDrawer={onClose} clear={onClear} testId='invoices.filter-drawer'>
      <Box className='h-full min-w-80'>
        <Box className='flex flex-1 flex-col'>
          <Typography variant='subtitle1' className='px-4 py-1.5 font-bold text-gray-700'>
            Status
          </Typography>
          <Divider />
          <InvoicesStatusFilter statuses={statuses} onChange={(values) => onChange("statuses", values)} />
        </Box>

        <Box className='flex flex-1 flex-col'>
          <Typography variant='subtitle1' className='px-4 py-1.5 font-bold text-gray-700'>
            Transaction Type
          </Typography>
          <Divider />
          <InvoicesTransactionTypeFilter
            invoiceType={invoiceType}
            onChange={(value) => onChange("invoiceType", value)}
          />
        </Box>

        <Box className='flex flex-1 flex-col'>
          <Typography variant='subtitle1' className='px-4 py-1.5 font-bold text-gray-700'>
            Vendor Name
          </Typography>
          <Divider />
          <InvoicesVendorFilter
            vendorCompanyId={vendorCompanyId}
            onChange={(value) => onChange("vendorCompanyId", value)}
          />
        </Box>
      </Box>
    </SearchFilterDrawer>
  )
}
